import { useQuery } from '@tanstack/react-query'
import { FormData, DiscountedCashFlowResponseData } from '../../Config/types'
import { fetchDiscountedCashFlow } from '../../requests/api'
import useAuthenticatedFetch from '../../requests/requestAuthenticated'

export const VALUATION_QUERY_KEY = 'valuation'

/**
 * Query hook for fetching discounted cash flow valuation data
 * 
 * @param formData - The form data to use for the valuation request
 * @param enabled - Whether the query should be enabled (defaults to true if symbols exist)
 */
export const useValuationQuery = (formData: FormData | null, enabled = true) => {
  const { fetchWithAuth } = useAuthenticatedFetch()
  
  return useQuery<DiscountedCashFlowResponseData>({
    queryKey: [VALUATION_QUERY_KEY, formData],
    queryFn: () => {
      if (!formData) {
        throw new Error('Form data is required')
      }
      return fetchDiscountedCashFlow(formData, fetchWithAuth)
    },
    enabled: enabled && !!formData && formData.symbols.length > 0,
  })
}

export default useValuationQuery
